import * as React from 'react';
import { SurveyVersionDataService } from '../../services';
import { SurveyVersion } from '../../models';
import { TopNavMenu } from '../navigation/TopNavMenu';
import { TopNavMenuItem } from '../navigation/TopNavMenuItem';
import { PVAPage } from '../../components';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { NavLink } from 'react-router-dom';

export class SurveyVersionListing extends React.Component<BaseRouteProps<{}>, ListingState<SurveyVersion>> {
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<SurveyVersion>(),
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.getAll().then((surveyVersions: SurveyVersion[]) => {
            this.setState(
                { entities: surveyVersions }
            );
        });
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to="/surveyversion/create">
                            <span className="glyphicon glyphicon-plus" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                    <div className="title">Survey Versions</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <table className="table">
                        <thead>
                            <tr>
                                <td>Survey Key</td>
                                <td>User</td>
                                <td>Completed</td>
                                <td>Expires</td>
                                <td />
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.entities.map((entity, index) => {
                                return <tr key={index}>
                                    <td />
                                    <td />
                                    <td />
                                    <td />
                                    <td>
                                        <NavLink className="btn btn-primary" to={`/surveyversion/${entity.id}`}>View</NavLink>
                                    </td>
                                </tr>;
                            })}
                        </tbody>
                    </table>
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}



// WEBPACK FOOTER //
// ./src/components/surveyversion/SurveyVersionListing.tsx